<template>
  <v-container>
    <rest-resource-table
      label="Fees"
      resource-name="fees"
      resource-id-name="feeid"
      :columns="columnHeaders"
      @saved="$store.dispatch('LOAD_CONFIG')"
      allow-new
      allow-delete
      edit-permission="editFees"
    >
      <template v-slot:form="{ item }">
        <div>
          <v-text-field label="Type" v-model="item.feetype"></v-text-field>
          <v-text-field
            label="System Name"
            v-model="item.feesystemname"
          ></v-text-field>
          <v-text-field
            label="Sort Code"
            v-model="item.sortcode"
          ></v-text-field>
          <v-text-field
            label="Revenue Code"
            v-model="item.revenuecode"
          ></v-text-field>
          <v-checkbox
            label="GST Exclusive"
            v-model="item.gstexclusive"
          ></v-checkbox>

          <lookup-select
            label="Batch Type"
            v-model="item.defbatchtype"
            lookup-name="BatchType"
          ></lookup-select>
          <lookup-select
            label="Cert Type"
            v-model="item.mappedcerttype"
            lookup-name="PracticingCertificateType"
          ></lookup-select>
          <lookup-select
            label="Practicing Status"
            v-model="item.mappedpractisingstatus"
            lookup-name="PractisingStatus"
          ></lookup-select>
        </div>
      </template>
    </rest-resource-table>
  </v-container>
</template>

<script>
import restResourceTable from "@/components/lib/RestResourceTable.vue";
export default {
  name: "FeeOptions",
  components: {
    restResourceTable
  },
  data() {
    return {
      columnHeaders: [
        { text: "ID", value: "feeid" },
        { text: "Type", value: "feetype" },
        { text: "System Name", value: "feesystemname" },
        { text: "Sort Code", value: "sortcode" },
        { text: "Revenue Code", value: "revenuecode" }
      ]
    };
  }
};
</script>
